import React, {useEffect, useState} from "react";
import {Box, Fade} from "@mui/material";
import {useSelector} from "../../../../../../../../redux/store";
import {FormControlLabel, FormGroup, Grid, Typography} from "@material-ui/core";
import {CheckboxGradient} from "../../../../../../../components/CheckboxGradient";
import {useDispatch} from "react-redux";
import {updateCompanyByProperty} from "../../../../../../../../redux/actions/companyActions";
import {retrieveCompanyOptions} from "../../../../../../../../services/companyService";
import {useTranslation} from "react-i18next";
import * as types from "../../../../../../../../constants";
import {LANGUAGE_INFO_MESSAGE} from "../../../../../../../../constants/values";

const LanguageSettingTab = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const companyByProperty = useSelector((state) => state.companyReducer.companyByProperty);
  const user = useSelector((state) => state.authReducer.user);
  const [options, setOptions] = useState<{value: string, display_name: string}[]>([])

  useEffect(() => {
    if (companyByProperty) {
      retrieveCompanyOptions(companyByProperty.id, user!.token).then((response) => {
        if (response.actions) {
          setOptions(response.actions.PUT.supported_languages.child.choices)
        }
      })
    }
  }, [])

  const handleChangeLanguage = async (code: string, value: boolean) => {
    let supportedLanguages = companyByProperty!.supported_languages
    if (value) {
        dispatch({
          type: types.ADD_TOAST,
          payload: {
            type: 'info',
            message: LANGUAGE_INFO_MESSAGE
          }
        })
        supportedLanguages.push(code)
      } else {
        supportedLanguages = supportedLanguages.filter((i) => i !== code)
      }
      dispatch(updateCompanyByProperty(companyByProperty!.id, user!.token, {supported_languages: supportedLanguages}))
  }

  const getLanguagesList = () => {
    if (companyByProperty && options?.length > 0) {
      return options.map((i) => (
        <Grid item>
          <FormControlLabel
            label={i.display_name}
            control={
              <CheckboxGradient
                checked={companyByProperty.supported_languages.some((language) => language === i.value )}
                onChange={(e) => handleChangeLanguage(i.value, e.target.checked)}
              />
            }/>
        </Grid>
      ))
    }
    return null
  }

  return (
    <Box>
      <Fade in={true}>
        <Box mt={4}>
          <Typography style={{fontWeight: 500, fontSize: '14px'}}>{t('select_language_the_widget_provide')}</Typography>
          <Box mt={3}>
            <FormGroup row={true}>
              <Grid container spacing={10}>
                {getLanguagesList()}
              </Grid>
            </FormGroup>
          </Box>
        </Box>
      </Fade>
    </Box>
  )
}

export default LanguageSettingTab